module.exports = __webpack_public_path__ + "static/img/img-icon.312b3c20.svg";